<template>
    <div @click="(e) => e.stopPropagation()" class="app-header_cost-evaluations">

        <addCostEvaluation style="cursor: default;" ref="add_cost_evaluation"
            :group_id="group_node.data.group_id" :group_full_name="group_node.data.full_name" :group="group_node.data"
            v-on:need_refresh="add_cost_evaluation_need_refresh"
        />
        <importModelFromXML style="cursor: default;" ref="import_model_from_xml" title="Импорт модели"
            :group_id="group_node.data.group_id" service="cadastral_groups" only_real_attrs
            v-on:need_refresh="() => add_cost_evaluation_need_refresh([ 'Сравнительный подход' ], true)"
        />

        <b-dropdown class="transparent without-after">
    
            <template #button-content>
                <base-icon name="more_vert" />
            </template>
    
            <b-dropdown-item
                v-if="! group_node.children.length
                && !group_node.data.has_cost_evaluation_individual
                && !group_node.data.not_editable
                && check_roles([ 'group_tree' ])
                "
                v-on:click="(e) => add_cost_evaluation(e)">
                Создать модель оценки КС
            </b-dropdown-item>
    
            <b-dropdown-item
                v-if="! group_node.children.length
                    && !group_node.data.has_cost_evaluation_profitable
                    && !group_node.data.has_cost_evaluation_expensive
                    && !group_node.data.has_cost_evaluation_comparative 
                    && check_roles([ 'group_tree' ])
                "
                v-on:click="() => add_individual()">
                Индивидуальный расчет
            </b-dropdown-item>
    
            <b-dropdown-item
                v-if="!group_node.data.not_editable
                    && !group_node.children.length
                    && !group_node.data.has_cost_evaluation_profitable
                    && !group_node.data.has_cost_evaluation_expensive
                    && !group_node.data.has_cost_evaluation_comparative
                    && !group_node.data.has_cost_evaluation_individual 
                    && check_roles([ 'model' ])
                "
                v-on:click="import_model_from_xml">
                Импорт модели оценки КС
            </b-dropdown-item>
    
            <b-dropdown-item
                v-if="group_node.data.not_editable
                    && check_roles(['cost'])
                    && !group_node.children.length
                    && (group_node.data.has_cost_evaluation_profitable
                    || group_node.data.has_cost_evaluation_expensive
                    || group_node.data.has_cost_evaluation_comparative)
                "
                v-on:click="set_cost">
                Рассчитать итоговую КС
            </b-dropdown-item>
    
            <!-- <b-dropdown-item v-if="group_node.data.has_cost_evaluation">Удалить модель оценки КС</b-dropdown-item> --><!-- #3910 -->
        </b-dropdown>
    </div>
</template>

<script>
import api from "../../api"
import addCostEvaluation from "../cadastral/groups/add_cost_evaluation"
import importModelFromXML from "../cadastral/groups/import_model_from_xml"
import variables from "../../api/variables"

export default
{
    props :
    {
        group_node: Object
    },

    components :
    {
		addCostEvaluation,
		importModelFromXML,
    },

    methods :
    {
        check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		add_individual()
        {
            this.$router.push("/cost_evaluations/" + this.group_node.data.group_id + "/individual")
        },

        add_cost_evaluation(e)
        {
            e.stopPropagation()
            this.$refs.add_cost_evaluation.execute()
        },

        add_cost_evaluation_need_refresh(cost_evaluation_types, imported = false)
        {
            var has_cost_evaluation = false

            let first_new_cost_evaluation_type

            if(cost_evaluation_types.find(type => type == "Сравнительный подход"))
            {
                if (!this.group_node.data.has_cost_evaluation_comparative)
                {
                    first_new_cost_evaluation_type = "Сравнительный подход"
                }

                this.group_node.data.has_cost_evaluation_comparative = true
                has_cost_evaluation = true

                if (imported)
                {
                    this.group_node.data.cost_evaluation_comparative_model_imported = true
                }
            }

            if(cost_evaluation_types.find(type => type == "Затратный подход"))
            {
                if (!first_new_cost_evaluation_type && !this.group_node.data.has_cost_evaluation_expensive)
                {
                    first_new_cost_evaluation_type = "Затратный подход"
                }

                this.group_node.data.has_cost_evaluation_expensive = true
                has_cost_evaluation = true
            }

            if(cost_evaluation_types.find(type => type == "Доходный подход"))
            {
                if (!first_new_cost_evaluation_type && !this.group_node.data.has_cost_evaluation_profitable)
                {
                    first_new_cost_evaluation_type = "Доходный подход"
                }

                this.group_node.data.has_cost_evaluation_profitable = true
                has_cost_evaluation = true
            }

            this.group_node.data.has_cost_evaluation = has_cost_evaluation

            
            if (first_new_cost_evaluation_type)
            {
                this.$router.push('/cost_evaluations/' + this.group_node.data.group_id + '/' + variables.CE_approaches.getCodeByFullname(first_new_cost_evaluation_type))
                    .catch((e) => {if (e.type != 2) console.error(e)})
            }
        },

        import_model_from_xml(e)
        {
            e.stopPropagation()
            this.$refs.import_model_from_xml.execute()
        },

        set_cost(event)
        {
            event.stopPropagation()

            var calculation_types = []
            if (this.group_node.data.has_cost_evaluation_comparative) calculation_types.push("Сравнительный подход")
            if (this.group_node.data.has_cost_evaluation_expensive) calculation_types.push("Затратный подход")
            if (this.group_node.data.has_cost_evaluation_profitable) calculation_types.push("Доходный подход")

            api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost",
                { id : this.group_node.data.group_id, calculation_types },
                response =>
                {
                    api.open_response_url(response)
                    this.$router.push('/cost_evaluations/' + this.group_node.data.group_id + '/results')
                        .catch((e) => {if (e.type != 2) console.error(e)})
                },
                { success_msg : "Расчет итоговой КС завершен" }
            )
        },
    }
}
</script>

<style>
.app-header_cost-evaluations
{
    color: var(--bft-neutral-900);
}
</style>
